import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      vipSystem: state => state.activities['vip-system'].vipSystem,
      vipSystemLoading: state => state.activities['vip-system'].vipSystemLoading,
      vipTiers: state => state.activities['vip-system'].vipTiers,
      vipTiersLoading: state => state.activities['vip-system'].vipTiersLoading,
      defaultCurrency: state => state.settings.defaultCurrency,
      settingMissionSettings: state => state.settings.missionSettings,
      defaultWebsiteData: state => state.settings.defaultWebsiteData
    }),
    isVipActive() {
      return this.missionStatusInfo.vip_status
    },
    missionStatusInfo() {
      const supportedCurrencyList = this.defaultWebsiteData?.supported_currencies_list
      if (!this.defaultCurrency)
        return {
          vip_status: true,
          mission_status: true
        }
      if (supportedCurrencyList?.length) {
        const websiteSettingByCurrency = supportedCurrencyList.find(
          el => el.code === this.defaultCurrency
        )
        if (websiteSettingByCurrency) {
          return {
            vip_status: websiteSettingByCurrency.vip_status === 1,
            mission_status: websiteSettingByCurrency.mission_status === true
          }
        }
      }
      return {
        vip_status: true,
        mission_status: true
      }
    },

    tiersList() {
      if (this.vipTiers?.tiers?.length) return this.vipTiers.tiers
      return []
    },
    tiersListWithoutCommonTier() {
      return this.tiersList.filter(el => el.tier_type === 1)
    },
    isTheHighestTier() {
      if (
        this.vipTiers?.player?.current_tier?.id ===
        this.vipTiers?.tiers?.[this.vipTiers?.tiers?.length - 1].id
      )
        return true
      return false
    }
  },
  methods: {
    getVipSettings() {
      this.$store.dispatch('activities/vip-system/getVipSettings', {
        currency: this.defaultCurrency
      })
    },
    getPlayerVipTier() {
      this.$store.dispatch('activities/vip-system/getVipTiers', {
        currency: this.defaultCurrency
      })
    },
    getRankProgress(currentAmount, ranks) {
      const amount = Number(currentAmount)

      // Find current rank index
      let currentRankIndex = -1
      for (let i = 0; i < ranks.length; i++) {
        const min = Number(ranks[i].min_range)
        const max = Number(ranks[i].max_range)
        if (amount >= min && amount < max) {
          currentRankIndex = i
          break
        }
      }

      if (currentRankIndex === -1) {
        return null // Not in any rank
      }

      const currentRank = ranks[currentRankIndex]
      const prevRank = ranks[currentRankIndex - 1] || null
      const nextRank = ranks[currentRankIndex + 1] || null
      let progressToNext = null

      if (nextRank) {
        const currMin = Number(currentRank.min_range)
        const currMax = Number(currentRank.max_range)
        const currAmount = amount

        progressToNext = (100 * (currAmount - currMin)) / (currMax - currMin)

        progressToNext = Math.max(0, Math.min(progressToNext, 100))
      }

      return {
        previousRank: prevRank,
        currentRank,
        nextRank,
        progressToNext: progressToNext !== null ? progressToNext.toFixed(2) : ''
      }
    },
    getVipTierConditionType(type) {
      if (type === 1) return this.tl('totalTurnover')
      if (type === 2) return this.tl('totalDeposit')
      if (type === 3) return this.tl('totalBetAmount')
      return ''
    }
  }
}
